<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary" depressed>
        <v-icon>mdi-account-circle</v-icon>&nbsp;
        {{ user ? (user.name ? user.name : user.user) : $t("message.account.login") }}
        <v-icon>mdi-menu-down</v-icon>
      </v-btn>
    </template>

    <template v-if="user">
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <template v-if="user.role">
              <v-list-item-title>{{ $t("message.account.login_as", { "role": $t("message.common.role_" + user.role) } ) }}</v-list-item-title>
            </template>
            <template v-else>
              <v-list-item-title>{{ $t("message.account.unlogin") }}</v-list-item-title>
            </template>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/profile">
          <v-list-item-action>
            <v-icon>mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("message.common.profile") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('logout')">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("message.account.logout") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>

    <template v-else>
      <v-list>
        <template v-for="idp in idps">
          <v-list-item @click="login(idp.iid)" :key="idp.name">
            <v-list-item-content>
              <v-list-item-title>{{ $t("message.account.login_with", { "idp": idp.name } ) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </template>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import { UserManager, Log } from '@rozetta/oidc-client'
import { login } from "../js/login";
import { http_error } from "../js/http_error";

export default {
  name: 'account',
  data: function(){
    return {
      module_id: "52",
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'idps'
    ]),
  },
  mixins: [login, http_error],
  created: function () {
    var domain = location.hostname.split(".");
    if(domain[0].endsWith("t-3mt")
      || domain[0].startsWith("localhost")){
      domain = "t-3mt";
    }else{
      domain = "the-reading";
    }

    if(this.$store.getters.debug){
      Log.logger = console;
      Log.level = Log.DEBUG;
    }
    if(this.$store.getters.auth){
      // 既にログイン済み
      return;
    }
    var idp_config_json = null
    try{
      idp_config_json = localStorage.getItem(domain + '_idp_config');
    }catch(e){
      // エラールート
      if(this.$store.getters.debug){
        console.error("getItem idp_config:" + e);
      }
      this.$store.commit("setNotification", {
        type: "warning",
        message: {
          eid: "E1" + this.module_id + "106" + ":00000005",
          param: {}
        }
      });
      return;
    }
    try{
      var idp_config = JSON.parse(idp_config_json);
      if(idp_config === null){
        return;
      }
    }catch(e){
      if(this.$store.getters.debug){
        console.error("idp_config:" + e);
      }
      this.$store.commit("setNotification", {
        type: "error",
        message: {
          // message: ログインエラー。
          eid: "E152312:00000005",
          param: {}
        }
      });
      this.reset_auth();
    }
    var um = new UserManager(idp_config.config);
    // renewの設定
    this.set_renew(um);
    if(window.location.pathname.endsWith('/auth/callback')){
      /* callback */
      // signinRedirectCallback
      um.signinRedirectCallback()
        .then(user => {
          if(this.$store.getters.debug){
            this.$store.commit("setNotification", { type: "debug", "message": "auth login" });
          }
          this.$store.commit("setAccessToken", user.access_token);
          this.$store.commit("setSessionState", user.session_state);
          this.get_profile();
          if(this.$route.path !== "/"){
            this.$router.push("/");
          }
        })
        .catch(error =>{
          // エラールート
          if(this.$store.getters.debug){
            console.error("signinRedirectCallback:" + error);
          }
          this.$store.commit("setNotification", {
            type: "error",
            message: {
              // message: ログインエラー。
              eid: "E152312:00000006",
              param: {}
            }
          });
          if(this.$route !== "/"){
            this.$router.push("/");
          }
          this.reset_auth();
        });
    }else{
      /* 通常 */
      // ユーザー情報の復元
      um.getUser()
        .then(user => {
          if(user){
            if(user.expired){
              um.signinRedirect()
                .catch(function (error) {
                  if(this.$store.getters.debug){
                    console.error("signinRedirect:" + error);
                  }
                  this.$store.commit("setNotification", {
                    type: "error",
                    message: {
                      // message: ログインエラー。
                      eid: "E152312:00000007",
                      param: {}
                    }
                  });
                  if(this.$route.path !== "/"){
                    this.$router.push("/");
                  }
                  this.reset_auth();
                });
            }else{
              this.$store.commit("setAccessToken", user.access_token);
              this.$store.commit("setSessionState", user.session_state);
              if(this.$store.getters.debug){
                this.$store.commit("setNotification", { type: "debug", "message": "auth already login" });
              }
              this.get_profile();
            }
          }
        })
        .catch(error =>{
          if(this.$store.getters.debug){
            console.error("getUser:" + error);
          }
          this.$store.commit("setNotification", {
            type: "error",
            message: {
              // message: ログインエラー。
              eid: "E152312:00000008",
              param: {}
            }
          });
          this.reset_auth();
        });
    }
    this.$store.commit("setAuth", um);
  },
  methods: {
    logout: function() {
      var um = this.$store.getters.auth;
      if(um === null){
        return;
      }
      this.$http.get(this.$store.getters.api_endpoint + "/logout")
        .then( response => {
          um.signoutRedirect()
            .then( () => {
              if(this.$store.getters.debug){
                this.$store.commit("setNotification", { type: "debug", "message": "auth logout" });
              }
              if(this.$route.path !== "/"){
                this.$router.push("/");
              }
              this.reset_auth();
            })
            .catch( error => {
              if(this.$store.getters.debug){
                console.error("logout:" + error);
              }
              this.$store.commit("setNotification", {
                type: "error",
                message: {
                  // message: ログアウトエラー。
                  eid: "E152313:00000000",
                  param: {}
                }
              });
              if(this.$route.path !== "/"){
                this.$router.push("/");
              }
              this.reset_auth();
            });
        })
        .catch( error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
          if(this.$route.path !== "/"){
            this.$router.push("/");
          }
          this.reset_auth();
        });
    }
  }
}
</script>
